import { Leaderboard } from '@tovia/man-protos/dist/types/content.types';
import { Models } from 'src/client/redux/modules/models';

const sharedFakeData = {
  galleriesCount: 0,
  headshotImagePathSfw: '',
  leaderboardViews: {} as Leaderboard,
  moviesCount: 0,
  ratingAverage: 0,
  siteUUID: 'E6B595104E3411DF98790800200C9A66',
  totalGalleries: 0,
  views: 0,
};

// Hardcoded list for now

// KellyCollins
// HillaryC
// AzzurraMoretti
// RinnaLy
// Clarice
// SarikaA
// IsaSweet
// AlexiaTae
export const aiModels: Models[] = [
  {
    ...sharedFakeData,
    name: 'Kelly Collins',
    headshotImagePath: '/media/headshots/kelly-collins.jpg',
    path: '/ai-chat/kelly-collins',
    UUID: 'C6AFF490B399E2B4C195A66B8F296438',
  },
  {
    ...sharedFakeData,
    name: 'Hilary C',
    headshotImagePath: '/media/headshots/hilary-c.jpg',
    path: '/ai-chat/hilary-c',
    UUID: '5784A15F6B087A34198B73B3774BB4D6',
  },
  {
    ...sharedFakeData,
    name: 'Azzurra Moretti',
    headshotImagePath: '/media/headshots/azzurra-moretti.jpg',
    path: '/ai-chat/azzurra-moretti',
    UUID: '8745978466DFF1F4418EE0533BCEA2C7',
  },
  {
    ...sharedFakeData,
    name: 'Rinna Ly',
    headshotImagePath: '/media/headshots/rinna-ly.jpg',
    path: '/ai-chat/rinna-ly',
    UUID: '7071B8734BE0AAC45D884DBDE84723F5',
  },
  {
    ...sharedFakeData,
    name: 'Clarice',
    headshotImagePath: '/media/headshots/clarice.jpg',
    path: '/ai-chat/clarice',
    UUID: '67CBE88ACD14E104C91BBCE7CB8B8DF9',
  },
  {
    ...sharedFakeData,
    name: 'Sarika A',
    headshotImagePath: '/media/headshots/sarika-a.jpg',
    path: '/ai-chat/sarika-a',
    UUID: 'DB8A793E3101C114458638EC6BC9A32D',
  },
  {
    ...sharedFakeData,
    name: 'Isa Sweet',
    headshotImagePath: '/media/headshots/isa-sweet.jpg',
    path: '/ai-chat/isa-sweet',
    UUID: '6C6D1D9E858AA55489B5C43E80FA9C1D',
  },
  {
    ...sharedFakeData,
    name: 'Alexia Tae',
    headshotImagePath: '/media/headshots/alexia-tae.jpg',
    path: '/ai-chat/alexia-tae',
    UUID: 'EC6C775E869DD5F4D111451D13D8FCE2',
  },
];
